import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { resolveSuperAdminAccess } from '../features/admin/adminAccess';

export default function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, isAdmin, isSuperAdmin } = useAuth();
  const decision = resolveSuperAdminAccess({
    loading,
    signedIn: !!user,
    isAdmin,
    isSuperAdmin,
  });

  if (decision === 'wait') return <div className="flex h-screen items-center justify-center">Loading...</div>;
  if (decision === 'login') return <Navigate to="/login" replace />;
  if (decision === 'home') return <Navigate to={isAdmin ? '/admin/users' : '/'} replace />;
  return <>{children}</>;
}
